import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { resolveRouting } from './orgRouting'

/**
 * Filet du routeur plateforme (#37). Ses routes publiques vivent hors du
 * basename d'org, donc un `navigate('/account')` depuis l'un de ces écrans vise
 * une route qui n'y existe pas. On repasse ici par la réécriture d'org, en
 * navigation dure : changer de basename est hors de portée de react-router.
 *
 * C'est aussi ce qui garantit qu'aucune autre route ne devient accessible en
 * forme nue par une navigation interne — seules `/signup`, `/confirm-trial` et
 * `/login` vivent à la racine.
 */
function PlatformFallback() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    window.location.replace(resolveRouting(pathname, search).redirectTo ?? '/')
  }, [pathname, search])

  return null
}

export default PlatformFallback
